module.exports = __webpack_public_path__ + "static/media/ls_logo_transparent.c9d6886f.png";